/**
 * A starter/reference component
 * copy & paste and replace with relevant content
 * or use simply as a reference
 */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@zillow/constellation-10';

import { ROOM_FOR_RENT_FLOW } from '../../../containers/CreateListingPage/constants';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../Wizard/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import WizardAlert from '../../WizardAlert';
import PageWizard from '../../Wizard/PageWizard';

import DetailedRoommateCountFormSectionContainer from './components/DetailedRoommateCountFormSectionContainer';
import TotalRoommateCountFormSectionContainer from './components/TotalRoommateCountFormSectionContainer';

import { WizardForm } from '../../../styles/wizard';

const propTypes = {
  onGoToPrevStep: PropTypes.func.isRequired,
  onGoToNextStep: PropTypes.func.isRequired,
  wizardTitle: PropTypes.node.isRequired,
  progressStepper: PropTypes.node.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(['md' | 'xl' | 'xxl']).isRequired,
};

const defaultProps = {};

const RoomHowManyRoommates = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}) => {
  const {
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { roomForRentFlow, serverErrorObj },
  } = useContext(ModularListingContext);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="RoomHowManyRoommates">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: {
              base: 'repeat(6, 1fr)',
              lg: 'repeat(12, 1fr)',
            },
            gap: '400',
          }}
        >
          <Box css={{ gridColumnEnd: { base: 'span 6', lg: 'span 12', xl: 'span 7' } }}>
            {/**
              TODO: remove title containers from form section container
              as we do not display the title in the edit review modal
            */}
            <WizardForm asChild={true} onSubmit={(e) => e.preventDefault()}>
              <div>
                {roomForRentFlow !== ROOM_FOR_RENT_FLOW.RYAN_FLOW ? (
                  <TotalRoommateCountFormSectionContainer />
                ) : (
                  <DetailedRoommateCountFormSectionContainer />
                )}
              </div>
            </WizardForm>
          </Box>
        </Box>
      </div>
    </PageWizard>
  );
};

RoomHowManyRoommates.propTypes = propTypes;
RoomHowManyRoommates.defaultProps = defaultProps;

export default RoomHowManyRoommates;
